import 'react';
import {Box, IconButton} from '@mui/material';
import {ExpandLess, ExpandMore} from '@mui/icons-material';
import {TREE_EXPAND_BUTTON_WIDTH} from '@/utils/treeTableHelpers';

export interface TreeExpandCellProps {
    hasChildren: boolean;
    isOpen: boolean;
    onToggle: () => void;
}

export function TreeExpandCell(props: TreeExpandCellProps) {
    const {hasChildren, isOpen, onToggle} = props;
    return (
        <Box sx={{display: 'flex', alignItems: 'center'}}>
            {hasChildren ? (
                <IconButton size="small" onClick={onToggle}>
                    {isOpen ? <ExpandLess/> : <ExpandMore/>}
                </IconButton>
            ) : (
                <Box sx={{width: TREE_EXPAND_BUTTON_WIDTH, flexShrink: 0}}/>
            )}
        </Box>
    );
}
